import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksMemoFields', {
    vendorMessageFieldTitle: 'Message to vendor',
    memoFieldTitle: 'Memo',
    messageOnInvoiceFieldTitle: 'Message on invoice',
    messageOnStatementFieldTitle: 'Message on statement',
    sectionTitle: 'Messages',
});
